import { bool, object } from 'prop-types';
import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import get from 'lodash.get';
import { getBuyerId } from 'dibs-cookie-jar';
import { GridRow, GridCol } from 'dibs-elements/exports/Grid';
import LinkColumn from './LinkColumn/LinkColumn';
import LinkColumnItem from './LinkColumn/LinkColumnItem';
import { FooterBottomRow } from './FooterBottomRow';

import { linkColumnConfig, filterLinks } from '../footerHelpers';
import style from './Footer-style.scss';

// to pad one column width of space on both edge of the footer
const PaddingGridCol = () => <GridCol desktop={1} />;

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = { isClient: false };
        this.updateUserState = this.updateUserState.bind(this);
        this.mapListItems = this.mapListItems.bind(this);
    }

    componentDidMount() {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState(prevState => {
            return { ...prevState, isClient: true };
        }, this.updateUserState);
    }

    componentDidUpdate(prevProps) {
        if (this.props.updateUserState && !prevProps.updateUserState) {
            this.updateUserState();
        }
    }

    updateUserState() {
        const userId = getBuyerId(document.cookie) || '';
        const hasUserId = !!userId;
        const refetchVariables = () => ({
            userId: userId,
            hasUserId,
        });

        this.props.relay.refetch(refetchVariables);
    }

    mapListItems({ CustomComponent, ...item }) {
        const { viewer } = this.props;
        const { isClient } = this.state;
        return CustomComponent ? (
            <CustomComponent key={item.dataTn} {...item} viewer={viewer} isClient={isClient} />
        ) : (
            <LinkColumnItem key={item.dataTn} {...item} />
        );
    }

    render() {
        const { isClient } = this.state;
        const { viewer, hideFooter } = this.props;

        return (
            <footer className={style.footer} hidden={hideFooter}>
                <React.Fragment>
                    <div className={style.footerRow}>
                        <GridRow>
                            <PaddingGridCol />
                            {linkColumnConfig.map(
                                (
                                    {
                                        enablerKey,
                                        disablerKey,
                                        columnWidth,
                                        title,
                                        items,
                                        additionalLink,
                                    },
                                    index
                                ) => {
                                    let showLinkColumn = true;
                                    if (enablerKey) {
                                        showLinkColumn = viewer[enablerKey] === true;
                                    }
                                    if (disablerKey) {
                                        showLinkColumn = viewer[disablerKey] === false;
                                    }
                                    return (
                                        showLinkColumn && (
                                            <GridCol
                                                key={`link-column-${index}`}
                                                desktop={columnWidth}
                                            >
                                                <LinkColumn title={title}>
                                                    {filterLinks(items, viewer).map(
                                                        this.mapListItems
                                                    )}
                                                </LinkColumn>
                                                {additionalLink && (
                                                    <div className={style.additionalLinkContainer}>
                                                        <LinkColumn title={additionalLink.title}>
                                                            {filterLinks(
                                                                additionalLink.items,
                                                                viewer
                                                            ).map(this.mapListItems)}
                                                        </LinkColumn>
                                                    </div>
                                                )}
                                            </GridCol>
                                        )
                                    );
                                }
                            )}
                            <PaddingGridCol />
                        </GridRow>
                    </div>
                    <FooterBottomRow
                        filterLinks={links => filterLinks(links, viewer)}
                        viewer={viewer}
                        isClient={isClient}
                    />
                </React.Fragment>
            </footer>
        );
    }
}

Footer.propTypes = {
    relay: object,
    updateUserState: bool,
    hideFooter: bool,
    viewer: object,
};

const mapStateToProps = state => {
    const updateUserState = get(state, 'header.updateUserState');
    return {
        updateUserState,
        hideFooter: get(state, 'header.hideFooter'),
    };
};

export default createRefetchContainer(
    connect(mapStateToProps)(Footer),
    {
        viewer: graphql`
            fragment Footer_viewer on Viewer {
                isTradeExperienceEnabled: isEnabledByLocale(featureName: "TRADE_EXPERIENCE")
                isSellerDirectoryEnabled: featureFlag(feature: "sellerDirectory")
                isSellerApplicationEnabled: isEnabledByLocale(featureName: "SELLER_APPLICATION")
                isAboutUsPageEnabled: isEnabledByLocale(featureName: "ABOUT_US_PAGE")
                isCareersPageEnabled: isEnabledByLocale(featureName: "CAREERS_PAGE")
                isPressPageEnabled: isEnabledByLocale(featureName: "PRESS_PAGE")
                isQuestionsPageEnabled: isEnabledByLocale(featureName: "QUESTIONS_PAGE")
                isSiteMapsEnabled: isEnabledByLocale(featureName: "HTML_SITE_MAPS")
                disableFooterSubscribe: isEnabled(key: "disableFooterSubscribe")
                ...CurrencySelector_viewer
                ...FooterBottomRow_viewer
                ...SocialLinkRow_viewer
                ...FooterSubscribe_viewer
            }
        `,
    },
    graphql`
        query FooterRefetchQuery($userId: String!, $hasUserId: Boolean!) {
            viewer {
                ...Footer_viewer
            }
        }
    `
);
